import * as React from 'react';
import {
    Stack,
    Typography,
    IconButton
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@iconify/icons-eva/close-outline';
import CloseOutlined from "@material-ui/icons/CloseOutlined";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "70%",
    height:"90%",
    bgcolor: 'background.paper',
    boxShadow: 50,
    border:"none"
};

const renderModalTitle = (props) => {
    if(!_.isEmpty(props.user)) {
        return <b style={{paddingLeft:"8.5px"}}>{props.user.name+"'s "+props.title}</b>; 
    } else {
        return <b>{props.title}</b>;
    }
    
}

export default function ModalCompoennt(props) {
    const { color = "#c29136" } = props;
    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            scroll={props.scroll}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            fullWidth
            maxWidth={props.width}
        >
            <Typography sx={{background:color,color:"white",padding:"18px",borderBottom:"1px solid black"}}>
                {renderModalTitle(props)} 
                <IconButton onClick={props.onClose} sx={{float:"right",padding:"0px", color:"white"}}>
                    <CloseOutlined />
                </IconButton>
            </Typography>
            <DialogContent dividers={scroll === 'paper'} sx={{width:"100%",padding:"0px"}}>
                <DialogContentText
                    id="scroll-dialog-description"
                    tabIndex={-1}
                >
                {props.children}
                </DialogContentText>
            </DialogContent>
        </Dialog>
    );
}
